import { makeStyles } from '@material-ui/core/styles';
import {
  PRIMARY,
  PRIMARY_10,
  PRIMARY_20,
  PRIMARY_80,
  WHITE,
} from '@/theme/theme';

// La app no monta ThemeProvider de Material-UI, así que `color="primary"` renderiza el azul por
// defecto de la librería. El verde de Billet se toma de las constantes del tema.
const useStyle = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(3),
    padding: theme.spacing(3),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  title: {
    color: PRIMARY,
    fontWeight: 600,
  },
  headerActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  // Material-UI pone los botones en mayúscula por defecto.
  primaryButton: {
    textTransform: 'initial',
    backgroundColor: PRIMARY,
    color: WHITE,
    '&:hover': {
      backgroundColor: PRIMARY_80,
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  },
  secondaryButton: {
    textTransform: 'initial',
    color: PRIMARY,
    borderColor: PRIMARY,
    '&:hover': {
      backgroundColor: PRIMARY_10,
      borderColor: PRIMARY,
    },
  },
  filterBar: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filterField: {
    minWidth: 180,
    flexGrow: 1,
    maxWidth: 240,
  },
  dateField: {
    minWidth: 150,
    flexGrow: 1,
    maxWidth: 190,
  },
  searchField: {
    minWidth: 240,
    flexGrow: 2,
  },
  clearFilters: {
    marginLeft: 'auto',
    textTransform: 'initial',
    color: PRIMARY,
    whiteSpace: 'nowrap',
  },
  chip: {
    height: 24,
    fontSize: '0.75rem',
    fontWeight: 500,
  },
  // Cada regla se ancla a `&.MuiChip-root` para ganar en especificidad. Con una sola clase se
  // empata con el gris por defecto del Chip y decide el orden de inyección de las hojas, que
  // varía según el orden de montaje. El texto se oscurece para cumplir contraste AA a 12px.
  chipDraft: {
    '&.MuiChip-root': {
      backgroundColor: '#FDECC8',
      color: '#7A5C00',
    },
  },
  chipInProgress: {
    '&.MuiChip-root': {
      backgroundColor: '#D7E9F7',
      color: '#125699',
    },
  },
  chipSuccess: {
    '&.MuiChip-root': {
      backgroundColor: PRIMARY_20,
      color: '#256B2A',
    },
  },
  chipError: {
    '&.MuiChip-root': {
      backgroundColor: '#FFDAD6',
      color: '#B3261E',
    },
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2),
    color: theme.palette.text.secondary,
  },
}));

export default useStyle;
